var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"locale_btns",class:{active_lang_dark: _vm.active_lang_darker}},_vm._l((_vm.getLanguages),function(lang){return _c('button',{class:{active: _vm.getSelectedLanguage === lang},attrs:{"type":"button"},on:{"click":function($event){return _vm.changeLanguage(lang)}}},[_vm._v("\n    "+_vm._s(lang.toUpperCase())+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }